import { AC_GROUPS, AC_TYPES } from '../AC.types.constant';
import { CriterionType } from '../../../types/screener.type';

const technicalIndicatorTrendAC: CriterionType[] = [
  {
    id: 'TECH-T-10',
    label: 'Short-term golden cross',
    shortLabel: 'STGoldX',
    group: AC_GROUPS.technicalIndicatorTrend,
    type: AC_TYPES.normal,
  },
  {
    id: 'TECH-T-20',
    label: 'Mid-term golden cross',
    shortLabel: 'MTGoldX',
    group: AC_GROUPS.technicalIndicatorTrend,
    type: AC_TYPES.normal,
  },
  {
    id: 'TECH-T-30',
    label: 'Short-term dead cross',
    shortLabel: 'STDeadX',
    group: AC_GROUPS.technicalIndicatorTrend,
    type: AC_TYPES.normal,
  },
  {
    id: 'TECH-T-40',
    label: 'Mid-term dead cross',
    shortLabel: 'MTDeadX',
    group: AC_GROUPS.technicalIndicatorTrend,
    type: AC_TYPES.normal,
  },
  {
    id: 'TECH-T-50',
    label: 'Above short-term ichimoku cloud',
    shortLabel: '>STIchi',
    group: AC_GROUPS.technicalIndicatorTrend,
    type: AC_TYPES.normal,
  },
  {
    id: 'TECH-T-60',
    label: 'Above mid-term ichimoku cloud',
    shortLabel: '>MTIchi',
    group: AC_GROUPS.technicalIndicatorTrend,
    type: AC_TYPES.normal,
  },
  {
    id: 'TECH-T-70',
    label: 'Below short-term ichimoku cloud',
    shortLabel: '<STIchi',
    group: AC_GROUPS.technicalIndicatorTrend,
    type: AC_TYPES.normal,
  },
  {
    id: 'TECH-T-80',
    label: 'Below mid-term ichimoku cloud',
    shortLabel: '<MTIchi',
    group: AC_GROUPS.technicalIndicatorTrend,
    type: AC_TYPES.normal,
  },
  {
    id: 'TECH-T-90',
    label: 'Bullish 3-line break',
    shortLabel: '3LBBull',
    group: AC_GROUPS.technicalIndicatorTrend,
    type: AC_TYPES.normal,
  },
  {
    id: 'TECH-T-100',
    label: 'Bearish 3-line break',
    shortLabel: '3LBBear',
    group: AC_GROUPS.technicalIndicatorTrend,
    type: AC_TYPES.normal,
  },
  {
    id: 'TECH-T-110',
    label: 'Bullish Bollinger breakout',
    shortLabel: 'BBBull',
    group: AC_GROUPS.technicalIndicatorTrend,
    type: AC_TYPES.normal,
  },
  {
    id: 'TECH-T-120',
    label: 'Bearish Bollinger breakout',
    shortLabel: 'BBBear',
    group: AC_GROUPS.technicalIndicatorTrend,
    type: AC_TYPES.normal,
  },
];

export default technicalIndicatorTrendAC;
